import {
  ActionItemStatus,
  MentoringProgramActionItem,
} from 'redux/schemas/models/mentoring-program-action-items';

export const CHECKBOX_SIZE = 24;

// Matches the rendered width of DeleteActionOption's trash icon button, so read-only
// rows (no delete button) still reserve the same trailing space and keep avatars aligned.
export const DELETE_BUTTON_SPACER_WIDTH = 28;

export const DEFAULT_ACTION_ITEM: MentoringProgramActionItem = {
  id: 0,
  description: '',
  assignedTo: null,
  dueDate: null,
  owner: null,
  status: ActionItemStatus.INCOMPLETE,
  completedAt: null,
  completedBy: null,
  isPreAssigned: false,
  required: false,
};
